
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-transparent bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 dark:bg-gradient-to-r dark:from-green-900/50 dark:to-emerald-900/50 dark:text-green-300 hover:bg-green-200 dark:hover:bg-green-900/80",
        warning:
          "border-transparent bg-gradient-to-r from-amber-100 to-yellow-100 text-amber-800 dark:bg-gradient-to-r dark:from-amber-900/50 dark:to-yellow-900/50 dark:text-amber-300 hover:bg-amber-200 dark:hover:bg-amber-900/80",
        info:
          "border-transparent bg-gradient-to-r from-blue-100 to-sky-100 text-blue-800 dark:bg-gradient-to-r dark:from-blue-900/50 dark:to-sky-900/50 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-900/80",
        purple:
          "border-transparent bg-gradient-to-r from-purple-100 to-violet-100 text-purple-800 dark:bg-gradient-to-r dark:from-purple-900/50 dark:to-violet-900/50 dark:text-purple-300 hover:bg-purple-200 dark:hover:bg-purple-900/80",
        pink:
          "border-transparent bg-gradient-to-r from-pink-100 to-rose-100 text-pink-800 dark:bg-gradient-to-r dark:from-pink-900/50 dark:to-rose-900/50 dark:text-pink-300 hover:bg-pink-200 dark:hover:bg-pink-900/80",
        gradient:
          "border-transparent bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-sm",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
